const settings = {
  NEED_HELP_LINK: 'NEED_HELP_LINK',
  PASSWORD_MIN_LENGTH: 'PASSWORD_MIN_LENGTH',
  TERMS_LINK: 'TERMS_LINK',
};

export default settings;
